import {
  Box,
  Stack,
  Typography,
} from "@mui/material"


function PageHeader({
  eyebrow,
  title,
  subtitle,
  actions,
  sx = {},
}) {
  return (
    <Box
      sx={{
        mb: 2,
        ...sx,
      }}
    >
      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        justifyContent="space-between"
        alignItems={{
          xs: "stretch",
          md: "flex-start",
        }}
        spacing={1.5}
      >
        <Box
          sx={{
            minWidth: 0,
          }}
        >
          {eyebrow ? (
            <Typography
              variant="overline"
              sx={{
                color: "primary.main",
                fontWeight: 900,
                letterSpacing: 0.8,
                lineHeight: 1.2,
              }}
            >
              {eyebrow}
            </Typography>
          ) : null}

          <Typography
            component="h1"
            sx={{
              mt: eyebrow ? 0.2 : 0,
              fontSize: {
                xs: 26,
                sm: 30,
                md: 34,
              },
              lineHeight: 1.08,
              fontWeight: 900,
              letterSpacing: -0.5,
              color: "text.primary",
            }}
          >
            {title}
          </Typography>

          {subtitle ? (
            <Typography
              color="text.secondary"
              sx={{
                mt: 0.55,
                maxWidth: 820,
                fontSize: {
                  xs: 13,
                  sm: 14,
                },
                lineHeight: 1.45,
              }}
            >
              {subtitle}
            </Typography>
          ) : null}
        </Box>

        {actions ? (
          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={1}
            sx={{
              flexShrink: 0,
              width: {
                xs: "100%",
                md: "auto",
              },

              "& > *": {
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              },
            }}
          >
            {actions}
          </Stack>
        ) : null}
      </Stack>
    </Box>
  )
}


export default PageHeader
